import React from 'react';

function LoadingDot() {
  return (
    <div className="w-3 h-3 bg-amber-500 rounded-full animate-pulse"></div>
  );
}

export default LoadingDot;